(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("plain-light-panelless", [], factory);
	else if(typeof exports === 'object')
		exports["plain-light-panelless"] = factory();
	else
		root["SurveyTheme"] = root["SurveyTheme"] || {}, root["SurveyTheme"]["PlainLightPanelless"] = factory();
})(this, () => {
return 